import React, { useEffect, useRef } from 'react'

export const QuizCard = ({ frontText, backText, isFlipped }) => {
  const frontRef = useRef(null)
  const backRef = useRef(null)
  const containerRef = useRef(null)

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const current = isFlipped ? backRef.current : frontRef.current
      if (current && containerRef.current) {
        containerRef.current.style.height = `${current.offsetHeight}px`
      }
    })

    if (frontRef.current) observer.observe(frontRef.current)
    if (backRef.current) observer.observe(backRef.current)

    const current = isFlipped ? backRef.current : frontRef.current
    if (current && containerRef.current) {
      containerRef.current.style.height = `${current.offsetHeight}px`
    }

    return () => observer.disconnect()
  }, [isFlipped])

  return (
    <div
      className="flashcard"
      ref={containerRef}
      style={{
        transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
        maxWidth: '540px',
        width: '100%',
      }}
    >
      {/* Front of card */}
      <div className="flashcard-front-back" ref={frontRef}>
        <p className="fs-xxl">&quot;{frontText}&quot;</p>
      </div>

      {/* Back of card */}
      <div className="flashcard-front-back card-back" ref={backRef}>
        <p className="text-center fs-lg">&quot;{backText}&quot;</p>
      </div>
    </div>
  )
}
